import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 17, height = 17, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 17 17' fill='none'>
  <path d='M14.5 10.5V13.1667C14.5 13.5203 14.3595 13.8594 14.1095 14.1095C13.8594 14.3595 13.5203 14.5 13.1667 14.5H3.83333C3.47971 14.5 3.14057 14.3595 2.89052 14.1095C2.64048 13.8594 2.5 13.5203 2.5 13.1667V10.5' stroke={color} stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M5.1665 7.16669L8.49984 10.5L11.8332 7.16669' stroke={color} stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M8.5 10.5V2.5' stroke={color} stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
</svg>
